


import { planningInboxRowsSelector } from '@/entities/gridTables/selectors/planningInboxRowsSelector'
import { useAppSelector } from '@/shared/store'

import { PlanningInboxGridRow } from '../models/PlanningInboxGridRow'

export type PlanningInboxTableData = {
  rows?: PlanningInboxGridRow[]
}

export const usePlanningInboxTableData = (): PlanningInboxTableData => {
  const rows = useAppSelector((state) => planningInboxRowsSelector.selectAll(state))

  return {
    rows: rows,
  }
}